import { extendTheme } from "@chakra-ui/react";
import { SCREEN_SIZE } from "./constants/common";

const breakpoints = {
  base: "0px",
  "2xs": SCREEN_SIZE["2XS"], // small mobile
  xs: SCREEN_SIZE.XS, // mobile
  sm: SCREEN_SIZE.SM, // small tablet
  md: SCREEN_SIZE.MD, // tablet
  lg: SCREEN_SIZE.LG, // pc
  xl: SCREEN_SIZE.XL, // large pc
  "2xl": SCREEN_SIZE.XXL,
};

export const theme = extendTheme({
  breakpoints,
  components: {
    Button: {
      baseStyle: {
        // _focus: {
        //   boxShadow: "none",
        //   borderWidth: "1px",
        //   borderColor: "#000",
        // },
        _hover: {
          bgColor: "#f5f5f5",
        },
        _active: {
          bgColor: "#e5e5e5",
        },
      },
    },
    Input: {
      baseStyle: {
        border: "#f5f5f5",
        _focus: {
          boxShadow: "0 0 0 1px #000",
          border: "none",
        },
        _active: {
          boxShadow: "0 0 0 1px #000",
          border: "none",
        },
      },
    },
  },
  styles: {
    global: {
      ".js-focus-visible :focus:not([data-focus-visible-added])": {
        outline: "none",
        // boxShadow: "none",
      },
    },
  },
  colors: {
    red: {
      50: "#FFF6F4",
      75: "#FFEFEB",
      100: "#FCEDED",
      200: "#FFD7CC",
      300: "#FFAF99",
      500: "#FF3600",
      700: "#E03100",
      900: "#DF3030",
      1000: "#CC2B00",
    },
    blue: {
      500: "#2A84FF",
    },
    yellow: {
      100: "#FEF8EC",
      500: "#F9DB9F",
      900: "#916208",
    },
    green: {
      100: "#EBFDFD",
      500: "#0BC196",
      700: "#089171",
      800: "#089710",
      900: "#06614B",
    },
    black: {
      1000: "#000000",
      900: "#1A1A1A",
      800: "#333333",
      700: "#4D4D4D",
      750: "#4C4C4C",
      600: "#666666",
      550: "#808080",
      500: "#999999",
      400: "#CBD5E0",
      300: "#CCCCCC",
      200: "#E5E5E5",
    },
    white: {
      0: "#FFFFFF",
      100: "#FBFBFB",
      200: "#FAFAFA",
      500: "#F5F5F5",
      700: "#F7F7F7",
      1000: "#F0F0F0",
    },
  },
  fontSize: {
    normal: "0.875rem",
    heading: "1.2rem",
    heading30: "1.875rem",
    heading36: "2.25rem",
  },
});
